import { gql } from "@apollo/client";

export const GET_CAMPAIGNS = gql`
  query getCampaigns {
    campaign {
      campaign_id
      name
      audience_roles
      created_at
      end_ts
      frequency
      org_id
      should_send_email
      start_ts
      updated_at
      users {
        user_id
        user {
          name
          email
          role
        }
      }
      surveys {
        survey {
          name
          survey_id
        }
        survey_id
      }
    }
  }
`;

export const GET_CAMPAIGN_BY_ID = gql`
  query getCampaignById($campaignId: uuid!) {
    campaign_by_pk(campaign_id: $campaignId) {
      campaign_id
      name
      audience_roles
      created_at
      end_ts
      frequency
      org_id
      should_send_email
      start_ts
      updated_at
      users {
        user_id
        user {
          name
          email
          role
        }
      }
      surveys {
        survey {
          name
          survey_id
        }
        survey_id
      }
    }
  }
`;

export const GET_CAMPAIGNS_BY_ORG_ID = gql`
  query getCampaignsByOrgId($orgId: uuid!) {
    campaign(where: { org_id: { _eq: $orgId } }) {
      campaign_id
      name
      audience_roles
      created_at
      end_ts
      frequency
      org_id
      should_send_email
      start_ts
      updated_at
      users {
        user_id
        user {
          name
          email
          role
        }
      }
      surveys {
        survey {
          name
          survey_id
        }
        survey_id
      }
    }
  }
`;

export const GET_USER_CAMPAIGNS = gql`
  query getUserCampaigns($userId: uuid!) {
    campaign_user(where: { user_id: { _eq: $userId } }) {
      campaign_user_id
      campaign_id
      user_id
      campaign {
        campaign_id
        name
        audience_roles
        created_at
        end_ts
        frequency
        org_id
        should_send_email
        start_ts
        updated_at
        surveys {
          survey {
            name
            survey_id
          }
          survey_id
        }
      }
    }
  }
`;
